.z{justify-content:center;}